const members = [
    {
        name: "John Rios",
        image: "/users/user-img-5.png",
        slogan: '"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Officiis fugit, ratione cumque nulla error quis molestias, velit labore voluptates nihil quia blanditiis soluta laboriosam a magni, non exercitationem unde laborum."',
    },
    {
        name: "Carol Silva",
        image: "/users/user-img-6.png",
        slogan: '"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Officiis fugit, ratione cumque nulla error quis molestias, velit labore voluptates nihil quia blanditiis soluta laboriosam a magni, non exercitationem unde laborum."',
    },
    {
        name: "Marianna Loreto",
        image: "/users/user-img-7.png",
        slogan: '"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Officiis fugit, ratione cumque nulla error quis molestias, velit labore voluptates nihil quia blanditiis soluta laboriosam a magni, non exercitationem unde laborum."',
    },
]

export default members